/**
 * Establish websocket connection, expose helper functions to send and receive
 * messages
 * @module Session
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as Guid from "./guid";
import { closeAll as closeAllPeers, removeAll as removeAllPeers } from "./peers";
import { servers as defaultIceServers } from "./ice";
import createLog from "./log";
var log = createLog("session");
function createWebSocket(onOpen, onClose, getAppState) {
    log("Creating new websocket");
    var host = window.location.host;
    if (process.env.NODE_ENV === "development") {
        host = process.env.SOCKET_URL;
    }
    var socket = new WebSocket("wss://" + host + ":443");
    socket.onopen = onOpen(socket);
    socket.onclose = function () {
        log("Socket closed");
        closeAllPeers();
        removeAllPeers();
        onClose();
        if (getAppState() === "disconnected") {
            log("Has been disconnected from session, no reconnect attempt");
            return;
        }
        setTimeout(function () {
            log("Reconnecting...");
            createWebSocket(onOpen, onClose, getAppState);
        }, 5 * 1000);
    };
    return socket;
}
export function init(options, onMessage) {
    var peerGuid = Guid.getPeerGuid() || Guid.createPeerGuid();
    var sessionGuid = Guid.getSessionGuid();
    var onOpen = function (socket) { return function () {
        log("<- Joining");
        session.socket = socket;
        socket.onmessage = onMessage;
        send(session, "joinPeer", __assign({ peersIdentifier: peerGuid }, options));
    }; };
    var session = {
        socket: createWebSocket(onOpen, options.onClose, options.getAppState),
        sessionGuid: sessionGuid,
        peerGuid: peerGuid,
        iceServers: defaultIceServers,
    };
    return session;
}
export function send(session, action, payload) {
    var json = JSON.stringify(__assign({ action: action, sessionGuid: session.sessionGuid }, payload));
    session.socket.send(json);
}
export function receive(receiverFn) {
    return function (event) {
        var _a = JSON.parse(event.data), action = _a.action, payload = __rest(_a, ["action"]);
        receiverFn(action, payload);
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/session.ts
// module id = 68
// module chunks = 1